export type UiSettingsVaultChangeSource = 'local' | 'remote';

export function shouldScheduleUiSettingsVaultSync(event: Event): boolean {
  const detail = (
    event as CustomEvent<{ source?: UiSettingsVaultChangeSource }>
  ).detail;
  return detail?.source !== 'remote';
}
